import { render, staticRenderFns } from "./CouponTaskList.vue?vue&type=template&id=24304238&"
import script from "./CouponTaskList.vue?vue&type=script&lang=js&"
export * from "./CouponTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports